// import { REGEX } from 'consts';

const inputs = {
  id: {
    id: 'worktemplate_id',
    name: 'id'
  },
  name: {
    id: 'name',
    name: 'name',
    input: 'textField',
    label: 'templateList.form.name.label',
    placeholder: 'templateList.form.name.placeholder',
    rules: {
      required: { value: true },
    },
  },
  description: {
    id: 'description',
    name: 'description',
    input: 'textArea',
    label: 'templateList.form.description.label',
    placeholder: 'templateList.form.description.placeholder',
    minRows: 2,
  },
  jobType: {
    id: 'jobType',
    name: 'jobType',
    input: 'select',
    label: 'templateList.form.jobType.label',
    helperText: 'templateList.form.jobType.helperText',
  },
  project: {
    id: 'proyect_id',
    name: 'project',
    input: 'autocomplete',
    label: 'templateList.form.project.label',
    helperText: 'templateList.form.project.helperText',
  },
  inventory: {
    id: 'inventory_id',
    name: 'inventory',
    input: 'select',
    label: 'templateList.form.inventory.label',
    helperText: 'templateList.form.inventory.helperText',
  },
  playbook: {
    id: 'playbook_id',
    name: 'playbook',
    input: 'select',
    label: 'templateList.form.playbook.label',
    helperText: 'templateList.form.playbook.helperText',
  },
  credential: {
    id: 'credentials_id',
    name: 'credential',
    input: 'selectChip',
    type: 'array',
    label: 'templateList.form.credential.label',
    helperText: 'templateList.form.credential.helperText',
    dontFormatResponse: true
  },
  forks: {
    id: 'forks',
    name: 'forks',
    type: 'number',
    input: 'textField',
    label: 'templateList.form.forks.label',
    helperText: 'templateList.form.forks.helperText',
    rules: {
      required: true,
    },
  },
  limit: {
    id: 'limit',
    name: 'limit',
    type: 'number',
    input: 'textField',
    label: 'templateList.form.limit.label',
    placeholder: 'templateList.form.limit.placeholder',
    helperText: 'templateList.form.limit.helperText',
  },
  levelDetail: {
    id: 'detail_level',
    name: 'levelDetail',
    type: 'number',
    input: 'select',
    label: 'templateList.form.levelDetail.label',
    helperText: 'templateList.form.levelDetail.helperText',
  },
  tagsJob: {
    id: 'work_tags',
    name: 'tagsJob',
    type: 'array',
    input: 'textField',
    label: 'templateList.form.tagsJob.label',
    placeholder: 'templateList.form.tagsJob.placeholder',
    helperText: 'templateList.form.tagsJob.helperText',
  },
  tagsSkip: {
    id: 'omit_tags',
    name: 'tagsSkip',
    type: 'array',
    input: 'textField',
    label: 'templateList.form.tagsSkip.label',
    placeholder: 'templateList.form.tagsSkip.placeholder',
    helperText: 'templateList.form.tagsSkip.helperText',
  },
  tags: {
    id: 'tags',
    name: 'tags',
    type: 'array',
    input: 'textField',
    label: 'templateList.form.tags.label',
    placeholder: 'templateList.form.tags.placeholder',
    helperText: 'templateList.form.tags.helperText',
  },
  timeout: {
    id: 'timeout',
    name: 'timeout',
    type: 'number',
    input: 'textField',
    label: 'templateList.form.timeout.label',
    helperText: 'templateList.form.timeout.helperText',
  },
  commandLine: {
    id: 'command_line',
    name: 'commandLine',
    input: 'textField',
    label: 'templateList.form.commandLine.label',
    placeholder: 'templateList.form.commandLine.placeholder',
    rules: {
      required: true,
    },
  },
  showChanges: {
    id: 'show_changes',
    name: 'showChanges',
    input: 'switch',
    label: 'templateList.form.showChanges.label',
    helperText: 'templateList.form.showChanges.helperText',
  },
  consultExecution: {
    id: 'show_changes_ask',
    name: 'consultExecution',
    input: 'switch',
    label: 'templateList.form.consultExecution.label',
    helperText: 'templateList.form.consultExecution.helperText',
  },
  enabledPrivileges: {
    id: 'enable_privileges',
    name: 'enabledPrivileges',
    input: 'checkbox',
    label: 'templateList.form.enabledPrivileges.label',
    helperText: 'templateList.form.enabledPrivileges.helperText',
  },
  enabledJobs: {
    id: 'activate_concurrent_works',
    name: 'enabledJobs',
    input: 'checkbox',
    label: 'templateList.form.enabledJobs.label',
    helperText: 'templateList.form.enabledJobs.helperText',
  },
  useCache: {
    id: 'use_event_cache',
    name: 'useCache',
    input: 'checkbox',
    label: 'templateList.form.useCache.label',
    helperText: 'templateList.form.useCache.helperText',
  },
  userProject: {
    id: 'user',
    name: 'userProject',
    input: 'select',
    label: 'templateList.form.userProject.label',
    helperText: 'templateList.form.userProject.helperText',
  },
  additionalVariables: {
    id: 'variables',
    name: 'additionalVariables',
    label: 'templateList.form.variables.label',
    helperText: 'templateList.form.variables.helperText',
  },
  notificationType: {
    id: 'tipo',
    name: 'notificationType',
    input: 'select',
    label: 'templateList.form.notificationType.label',
  },
  notifications: {
    id: 'notifications',
    type: 'array',
    name: 'notifications',
  },
  pollingType: {
    id: 'type',
    name: 'pollingType',
    input: 'select',
    label: 'templateList.form.pollingType.label',
  },
  pollings: {
    id: 'user_interaction',
    type: 'array',
    name: 'pollings',
  },
  pollingVariable: {
    id: 'var_name',
    name: 'pollingVariable',
    input: 'textField',
    label: 'templateList.form.pollingVariable.label',
    placeholder: 'templateList.form.pollingVariable.placeholder',
    rules: {
      required: true,
    },
  },
  pollingDescription: {
    id: 'desc',
    name: 'pollingDescription',
    input: 'textField',
    label: 'templateList.form.pollingDescription.label',
    placeholder: 'templateList.form.pollingDescription.placeholder',
  },
  pollingNumberTo: {
    id: 'pollingNumberTo',
    name: 'pollingNumberTo',
    input: 'textField',
    type: 'number',
    label: 'templateList.form.pollingNumberTo.label',
    placeholder: 'templateList.form.pollingNumberTo.placeholder',
  },
  pollingNumberFrom: {
    id: 'pollingNumberFrom',
    name: 'pollingNumberFrom',
    input: 'textField',
    type: 'number',
    label: 'templateList.form.pollingNumberFrom.label',
    placeholder: 'templateList.form.pollingNumberFrom.placeholder',
  },
  pollingRange: {
    id: 'range',
    name: 'pollingRange'
  },
  pollingOptionValue: {
    id: 'pollingOptionValue',
    name: 'pollingOptionValue',
    input: 'textField',
    type: 'number',
    label: 'templateList.form.pollingOptionValue.label',
    placeholder: 'templateList.form.pollingOptionValue.placeholder',
  },
  pollingOptionDescription: {
    id: 'pollingOptionDescription',
    name: 'pollingOptionDescription',
    input: 'textField',
    label: 'templateList.form.pollingOptionDescription.label',
    placeholder: 'templateList.form.pollingOptionDescription.placeholder',
  },
  pollingOptionsValues: {
    id: 'pollingOptionsValues',
    name: 'pollingOptionsValues',
  },
};

export default inputs;
